export default "__VITE_ASSET__CbgqPTy4__"